import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { Button } from '@/components/ui/button';
export function RefetchButton(t0) {
  const $ = _c(16);
  const {
    isFetching,
    refetch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("aspect-square max-h-full p-0 [--sq-r:.625rem]");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== refetch) {
    t2 = () => refetch();
    $[1] = refetch;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isFetching ? "" : "hidden";
  let t4;
  if ($[3] !== t3) {
    t4 = clsx("icon-[lucide--loader-2] size-3.5 animate-spin", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <svg className={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = isFetching ? "hidden" : "";
  let t7;
  if ($[7] !== t6) {
    t7 = clsx("icon-[ion--refresh] size-4", t6);
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <svg className={t7} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isFetching || $[12] !== t2 || $[13] !== t5 || $[14] !== t8) {
    t9 = <Button variant="ghost" disabled={isFetching} className={t1} onClick={t2}>{t5}{t8}</Button>;
    $[11] = isFetching;
    $[12] = t2;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}